<template>
  <div class="container">
    <el-tabs class="tabs" v-model="activeName">
      <el-tab-pane :label="$t('dashboard', 'myStatistics')" name="first"><my-statistics :type="activeName == 'first' && 1" v-if="activeName == 'first'" /></el-tab-pane>
      <template v-if="userInfo && (userInfo.roleId || jurisdiction || userInfo.main)">
        <el-tab-pane :label="$t('dashboard', 'enterpriseStatistics')" name="second"><enterprise :type="activeName == 'second' && 2" v-if="activeName == 'second'" /></el-tab-pane>
      </template>
      
    </el-tabs>
  </div>
</template>

<script>
import myStatistics from './components/myStatistics';
import enterprise from './components/enterprise';
import { mapState,mapMutations } from 'vuex';
import i18nMixin from '@/mixins/i18nMixin';
export default {
  name: "dashboard",
  mixins: [i18nMixin],
  components:{
    myStatistics,
    enterprise
  },
  data() {
    return {
      userInfo: this.$store.state.loginRoot.userInfo,
      activeName:'first',
      jurisdiction:''
    };
  },
  computed: {
    ...mapState(['routerArr']),
  },
  watch:{
    routerArr(val){
      console.log(val)
      this.jurisdiction = val.includes('00')
    }
  },
  created(){
    
  },
  methods:{

    
  }
};
</script>

<style scoped lang='scss'>
/deep/.el-tabs__header{
  margin-bottom: 16px !important;
}
</style>